import { Box } from "@mui/material";
import { useBrandingContext } from "../../BrandingContext";

export default function HeaderLogo({ boxSx, contrast, small }) {
  const { branding } = useBrandingContext();

  let logoPath = "/images/Logos-UICharitableAdvisors-SpaceBlue.png";
  let contrastLogoPath = "/images/Logos-UICharitableAdvisors-White.svg";
  let smallLogo = "/images/Logos-UICharitableAdvisors-SmallBlue.svg";

  return (
    <Box sx={{ ...boxSx }}>
      <a
        href={branding?.homeUrl ? branding?.homeUrl : "https://www.uicharitable.org"}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          id="brand-logo"
          className="brand-logo"
          src={
            contrast
              ? branding?.contrastLogo
                ? branding?.contrastLogo
                : branding?.smallLogo
                ? branding?.smallLogo
                : contrastLogoPath
              : small
              ? branding?.smallLogo
                ? branding?.smallLogo
                : branding?.logo || smallLogo
              : branding?.logo
              ? branding?.logo
              : logoPath
          }
          alt="Brand Logo"
          style={{ height: "100%" }}
        />
      </a>
    </Box>
  );
}
